/**
 * useDesktopSync
 *
 * Wires Electron IPC control commands (pause / resume / stop) back into the
 * PomodoroContext. Mount this hook once inside PomodoroProvider in App.tsx.
 *
 * Only active in the main Electron window — no-op on web and iOS.
 */

import { useEffect } from 'react';
import { usePomodoro } from '@/hooks/usePomodoroTimer';
import { listenForDesktopControls, isMainDesktopWindow, syncDesktopPrefs } from '@/lib/desktopBridge';

function DesktopSyncInner(): null {
  const { pauseTimer, resumeTimer, stopTimer } = usePomodoro();

  // Push persisted widget prefs to the main process on load (survives restarts).
  useEffect(() => {
    syncDesktopPrefs();
  }, []);

  useEffect(() => {
    if (!isMainDesktopWindow()) return;

    return listenForDesktopControls({
      onPause:  pauseTimer,
      onResume: resumeTimer,
      onStop:   stopTimer,
    });
  }, [pauseTimer, resumeTimer, stopTimer]);

  return null;
}

export { DesktopSyncInner };
